/**
 * WelcomeMessage Component
 *
 * Displays a welcome message with company information
 */

import { useCompany } from '@/contexts/CompanyContext';
import companyLogo from '@/assets/images/10001_logo.png';

export function WelcomeMessage() {
  const { company } = useCompany();

  return (
    <div className="mb-8 text-center w-full">
      {company?.companyLogo && (
        <div className="flex justify-center mb-3">
          <img
            src={companyLogo}
            alt={company.companyName}
            className="h-20 w-20 rounded-b-lg object-contain shadow-sm border border-gray-100"
          />
        </div>
      )}
      <h1 className="text-2xl font-bold text-gray-900 mb-4">Thank you for your generosity!</h1>
      <p className="text-xl text-gray-600 mx-auto px-4">
        Welcome to {company?.companyName || 'our'} donation portal. Your contribution will help us
        serve our community and support those in need.
      </p>
    </div>
  );
}
